export enum EPreviousCertificationSelectAction {
  NOT_FOUND = 'NOT_FOUND',
  SELECTED = 'SELECTED',
}
